import { Injectable } from "../di/index.js";
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : null === desc ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
class DOMActionRuntime {
    bind(root, actions) {
        const cleanups = Object.entries(actions).map(([eventName, definitions])=>{
            const listener = (event)=>{
                this.handleEvent(root, event, definitions || []);
            };
            root.addEventListener(eventName, listener);
            return ()=>root.removeEventListener(eventName, listener);
        });
        return ()=>{
            cleanups.forEach((cleanup)=>cleanup());
        };
    }
    handleEvent(root, event, definitions) {
        const target = this.normalizeTarget(event.target);
        if (!target) return;
        for (const definition of definitions){
            const delegateTarget = this.findDelegateTarget(root, target, definition.selector);
            if (!delegateTarget) continue;
            const context = this.createContext(root, event, target, delegateTarget);
            if (!definition.keys || this.matchesKeyFilter(event, definition.keys)) {
                if (!definition.guard || definition.guard(context)) {
                    if (definition.preventDefault) event.preventDefault();
                    if (definition.stopPropagation) event.stopPropagation();
                    try {
                        const result = definition.handler(context);
                        if (result && 'function' == typeof result.then) result.catch((error)=>{
                            console.error('[DOMActionRuntime] Async action failed:', error);
                        });
                    } catch (error) {
                        console.error('[DOMActionRuntime] Action failed:', error);
                    }
                }
            }
        }
    }
    createContext(root, event, target, delegateTarget) {
        return {
            event,
            root,
            target,
            delegateTarget,
            find: (selector, parent)=>(parent || delegateTarget).querySelector(selector) || null,
            findAll: (selector, parent)=>Array.from((parent || delegateTarget).querySelectorAll(selector)),
            closest: (selector, from)=>{
                const candidate = (from || target).closest(selector);
                return this.isWithinRoot(root, candidate) ? candidate : null;
            }
        };
    }
    normalizeTarget(target) {
        if (target instanceof HTMLElement) return target;
        if (target instanceof Element) return target;
        if (target instanceof Node) return target.parentElement;
        return null;
    }
    findDelegateTarget(root, target, selector) {
        if ('*' === selector) return target;
        const candidate = target.closest(selector);
        return this.isWithinRoot(root, candidate) ? candidate : null;
    }
    isWithinRoot(root, candidate) {
        if (!candidate) return false;
        if (root instanceof Document) return root.documentElement.contains(candidate);
        return root instanceof Node ? root.contains(candidate) : false;
    }
    matchesKeyFilter(event, keys) {
        return event instanceof KeyboardEvent && keys.includes(event.key);
    }
}
DOMActionRuntime = _ts_decorate([
    Injectable
], DOMActionRuntime);
export { DOMActionRuntime };
